module.exports = __webpack_public_path__ + "static/media/IMG_1696.cd7bdb3e.JPG";